$(document).ready(function () {
    if ($('.toFromLLA').length > 0 || $('.tabbedContent').length > 0) {
        $('.widget-zone-area').hide();
        $('.widget-zone-area').removeClass('no-visibility');
        $('.overlay').show();
        $('.panel-link').on('click', function () {
            var $this = $(this);
            var panelAreaId = $this.attr('panel-area-id');
            var panelArea = $('#' + panelAreaId);

            $this.addClass('active');
            $('.top-row').not(this).removeClass('active');
            $('.widget-zone-area').hide();
            $('.hide-by-default').show();
            $('.panel-area').hide();
            $('.main').hide();
            panelArea.fadeIn();

            if ($this.hasClass('hlFlyingFromLLA')) {
                WizardScroll('.bottomScrollFromLLA', 0);
            }
            else if ($this.hasClass('hlFlyingToLLA')) {
                WizardScroll('.bottomScrollToLLA', 0);
            } else {
                WizardScroll('#' + panelAreaId, 25);
            }
        });

        $('.zone-link').on('click', function () {
            //fix for tablets & mobile to realign columns
            salvattore.rescanMediaQueries();

            var widgetZoneArea = $(this);
            var widgetZoneAreaId = widgetZoneArea.attr('widget-zone-area-id');
            var parentPanelArea = widgetZoneArea.closest('.panel-area');

            if ($('.tabbedContent').length > 0)
            {
                $('.tabbedContent__mainContent').addClass('hidden');
            }

            $('.main').fadeIn();
            $(this).addClass('active');
            $('.zone-link').not(this).removeClass('active');
            $('.panel-area').not(parentPanelArea).hide();
            $('.widget-zone-area').hide();
            $('.hide-by-default').show();
            $('#' + widgetZoneAreaId).fadeIn();
            WizardScroll('#' + widgetZoneAreaId, 25);
        });

        $('.top-row').on('click', function () {
            var panelAreaId = $(this).attr('id');

            $('.top-row').not(this).removeClass('active');
            $('#HdnTopRow').val(panelAreaId);
        });

        $('.bottom-row').on('click', function () {
            var panelAreaId = $(this).attr('id');
            $('#HdnBottomRow').val(panelAreaId);
        });

        if ($('#HdnTopRow').val() !== '') {
            var hdnTopRow = $('#HdnTopRow').val();
            $('#' + hdnTopRow).trigger('click');

            if ($('#HdnBottomRow').val() !== '') {
                var hdnBottomRow = $('#HdnBottomRow').val();
                $('#' + hdnBottomRow).trigger('click');
            }
        }
    }
});